export const TimesheetOperationTypeInts = Object.freeze({
  ACCEPT: 0,
  MODIFY: 1,
  CANCEL: 2,
  toFriendlyString: (type) => {
    switch (type) {
      case TimesheetOperationTypeInts.ACCEPT:
        return 'Accepted'
      case TimesheetOperationTypeInts.MODIFY:
        return 'Modified'
      case TimesheetOperationTypeInts.CANCEL:
        return "Didn't happen"
    }
  },
})
